<div>
    <span>
        {{ isExpanded
        ? text
        : (text | slice: 0:maxLength) + (text.length > maxLength ? '...' : '') }}
    </span>
    <a *ngIf="text.length > maxLength" (click)="toggleExpand()" class="toggle-text">
        {{ isExpanded ? 'minder' : 'meer' }}
    </a>
</div>